import { useEffect, useRef, useState } from 'react'
import ReactTooltip from 'react-tooltip'

import styles from './Chat.module.scss'

const SCROLL_THRESHOLD = 500

const Chat = ({ children, noCompose = false, disabled }) => {
  const [showBackToBottom, setShowBackToBottom] = useState()
  const footerRef = useRef()
  const containerRef = useRef()

  function handleScroll() {
    if (!containerRef.current) {
      return
    }

    const { scrollTop, clientHeight, scrollHeight } = containerRef.current

    if (scrollHeight - scrollTop > clientHeight + SCROLL_THRESHOLD) {
      setShowBackToBottom(true)
    } else {
      setShowBackToBottom(false)
    }
  }

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (Element.prototype.scrollIntoView && footerRef.current) {
      setTimeout(() => {
        if (footerRef.current) {
          footerRef.current.scrollIntoView()
        }
      }, 0)
    }
  }, [children.length])

  return (
    <div
      className={[
        styles.container,
        noCompose ? styles.containerFullHeight : '',
        disabled ? styles.containerDisabled : ''
      ].join(' ')}
      ref={containerRef}
    >
      {children}
      {showBackToBottom && !noCompose && (
        <button
          onClick={() => footerRef.current.scrollIntoView({ behavior: 'smooth' })}
          className={styles.backToBottom}
        >
          Go to recent messages
        </button>
      )}
      <ReactTooltip />
      <div ref={footerRef}></div>
    </div>
  )
}

export default Chat
